export default Object.freeze({
  INTERNAUT: 'InnsoChatInternaut',
  AGENT: 'InnsoChatUser',
})
